import React from "react";
import style from '../style.module.scss';
import { IDonutGraphProps } from "../types";
import { LabelSeries, RadialChart } from "react-vis";
import { Paper, Typography } from "@material-ui/core";

const NS = 'DonutGraph';

/**
 * Renders the Donut graph with the provided series points.
 */
export const DonutGraph = (props: IDonutGraphProps) => {
  return (
    <div className={style.donutChart}>
      <RadialChart
        colorType="literal"
        data={props.donutGraphData}
        innerRadius={100}
        radius={150}
        getLabel= {(d: any) => `${d.angle}%`}
        color={(d: any)=> d.color}
        animation={"gentle"}
        height={300}
        width={300}
      >
        <LabelSeries data={[{x: 0, y: 0, label: props.valueLabel }]} className={style.donutLabel} />
      </RadialChart>
      { !!props.title && <Typography variant="h6" gutterBottom component="div">{props.title}</Typography> }
      { !!props.legends &&
        <Paper>
          <Typography variant="h6" gutterBottom component="div">{props.legends}</Typography>
        </Paper>

      }
    </div>
  );
}
